<template>
  <div
    class="home"
    v-show="visible"
  >
    <h5>修改</h5>
    <a-form
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :model="formState"
      @finish="handleFinish"
    >
      <a-form-item
        class="ipt"
        label="上级菜单"
      >
        <a-cascader
          v-model:value="parentMenu"
          :options="menuList"
          :field-names="fieldNames"
          expand-trigger="hover"
          change-on-select
          placeholder="Please select"
          @change="change"
        />
      </a-form-item>
      <a-form-item
        class="ipt"
        label="名称"
        required
      >
        <a-input
          v-model:value="formState.menuName"
          placeholder="请输入"
        >
        </a-input>
      </a-form-item>
      <a-form-item
        class="ipt"
        label="类型"
      >
        <a-radio-group v-model:value="formState.type">
          <a-radio value="0">菜单</a-radio>
          <a-radio value="1">按钮</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        class="ipt"
        label="图标"
        v-if="formState.type == '0'"
      >
        <a-input
          v-model:value="formState.icon"
          placeholder="请输入"
        >
          <template #suffix>
            <AppstoreOutlined @click="icon" />
          </template>
        </a-input>
      </a-form-item>
      <a-form-item
        class="ipt"
        label="URL"
        v-if="formState.type == '0'"
      >
        <a-input
          v-model:value="formState.path"
          placeholder="请输入"
        >
        </a-input>
      </a-form-item>
      <a-form-item
        class="ipt"
        label="组件"
        v-if="formState.type == '0'"
      >
        <a-input
          v-model:value="formState.component"
          placeholder="请输入"
        >
        </a-input>
      </a-form-item>
      <a-form-item
        class="ipt"
        label="权限"
      >
        <a-input
          v-model:value="formState.perms"
          placeholder="请输入"
        >
        </a-input>
      </a-form-item>
      <a-form-item
        class="ipt"
        label="排序"
        v-if="formState.type == '0'"
      >
        <a-input-number
          v-model:value="formState.orderNum"
          :min="1"
          :max="100"
        />
      </a-form-item>
      <a-form-item
        class="ipt a-btn"
        label="&nbsp;"
      >
        <a-button class="cancel">取消</a-button>
        <a-button
          class="confirm"
          html-type="submit"
        >确定</a-button>
      </a-form-item>
    </a-form>
    <Icon ref="icon" />
  </div>
</template>

<script>
// @ is an alias to /src
import { AppstoreOutlined } from '@ant-design/icons-vue';
import Icon from "@/components/system/menu/icon.vue";
import { alterMenu } from "@/api/system/system.js";

export default {
  name: "AlterMenu",
  components: {
    AppstoreOutlined,
    Icon
  },
  data() {
    return {
      visible: false,
      labelCol: {
        span: 5,
        align: 'top'
      },
      wrapperCol: {
        span: 17
      },
      fieldNames: {
        label: 'title',
        value: 'id'
      },
      parentMenu: [], // 上级部门名称
      formState: {
        parentId: '',
        menuName: '',
        type: 0,
        icon: '',
        path: '',
        component: '',
        perms: '',
        orderNum: ''
      },
    }
  },
  props: ['menuList', 'checkedKey', 'checkedTitle', 'present'],
  updated() {
    this.formState = this.present
    this.formState.menuName = this.present.title
    this.formState.menuId = this.present.id
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    icon() {
      this.$refs.icon.show();
    },
    change(value, selectedOptions) {
      console.log(value, selectedOptions)
      this.formState.parentId = value[value.length - 1]
      console.log(this.formState.parentId)
    },
    handleFinish() {
      alterMenu(this.formState).then(res => {
        if (res.code == 200) {
          this.$message.success(res.data);
          this.$emit('confirm')
        }
      }).catch(res => {
        console.log(res)
      });
    }
  }
};
</script>
<style scoped>
.ipt {
  text-align: left;
}

.ipt input {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.ipt :deep() .ant-cascader-input.ant-input {
  height: 36px;
  line-height: 36px;
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.ant-select :deep() .ant-select-selector {
  height: 36px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ant-select :deep() .ant-select-selection-item {
  height: 34px;
  line-height: 34px;
}
</style>
